import { render, staticRenderFns } from "./FundsRecordItem.vue?vue&type=template&id=5e2fd4aa&scoped=true&"
import script from "./FundsRecordItem.vue?vue&type=script&lang=js&"
export * from "./FundsRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./FundsRecordItem.vue?vue&type=style&index=0&id=5e2fd4aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2fd4aa",
  null
  
)

export default component.exports